import { render, staticRenderFns } from "./TemplateModalContent.vue?vue&type=template&id=9708e07a"
import script from "./TemplateModalContent.vue?vue&type=script&lang=ts"
export * from "./TemplateModalContent.vue?vue&type=script&lang=ts"
import style0 from "./TemplateModalContent.vue?vue&type=style&index=0&id=9708e07a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports